import i18next from "../../../i18n";

i18next.addResources("en", "Upload", {
    change_file: "Change file",
});
i18next.addResources("fr", "Upload", {
    change_file: "Changer le fichier",
});
